import { ProjectPermissions } from './Project';

/**
 * Enum that list the keys of the system groups.
 */
export enum SystemGroups {
  AllUsers = 'All users',
  Administrators = 'Administrators',
}

// taken from the API
export interface RealmGroupInfo {
  id: number;
  name: string;
  realmId: number;
  createdByRealmUserId: number;
  system: boolean;
  groupPublicKey: string | undefined;
  encryptedGroupPrivateKey: string | undefined; // Private key of the group encrypted with the user's public key
  memberCount: number;
}

// specific to the frontend, and when we now that the permissions are set
export interface ProjectGroup extends RealmGroupInfo {
  permissions: ProjectPermissions | undefined;
}

export interface RealmGroupMembership {
  id: number;
  groupPublicKey: string;
  encryptedGroupPrivateKey: string;
  realmGroupId: number;
  userPublicKey: string;
}

export interface EncryptedGroupMember {
  encryptedGroupPrivateKey: string;
  groupPublicKey: string;
  memberPublicKey: string;
}

/**
 * The RealmGroupPolicy defines which groups need to be included when creating
 * projects. I.e. they define who/what has access.
 *
 * - all: The 'All users' group *needs* to be added the project access list.
 * - admin: The 'Administrators' group *needs* to be added to the project
 *   access list.
 * - all+admin: Both the 'All users' and 'Administrators' group *needs* to
 *   be added to the project access list.
 * - private: There are no groups which *needs* to be added to the project
 *   access list.
 */
export enum RealmGroupPolicy {
  all,
  admin,
  'all+admin',
  private,
}
export type RealmGroupPolicyKeys = keyof typeof RealmGroupPolicy;

/**
 * The RealmGroupGuestPolicy defines to what type of groups a guest/partner
 * can belong.
 *
 * - not_allowed: Guests are not allowed to be added to groups.
 * - in_regular_groups: Guests are allowed to be part of regular (non system) groups.
 * - in_system_groups: Guests are allowed to be part of system groups.
 * - allowed_in_all_groups: Guests are allowed to be part of all types of
 *   groups.
 */
export enum RealmGroupGuestPolicy {
  not_allowed,
  in_regular_groups,
  in_system_groups,
  allowed_in_all_groups,
}
export type RealmGroupGuestPolicyKeys = keyof typeof RealmGroupGuestPolicy;
